const enumProcesso = {
    "ES": "Estoque",
    "MP": "Máq. Parada",
    "NO": "Normal",
    "UR": "Urgente"
}
export function obterPrioridade(code) {
    return enumProcesso[code];
}